import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { Enseigne } from "../../Models/Magasin/MagasinModels";
import { errorService } from "../Error/ErrorService";
import { TypeMagasinService } from "./TypeMagasinService";
import { SousGroupeService } from "./SousGroupeService";

export function EnseigneService(){
    return{
        async getEnseignes(token:string):Promise<Enseigne[]>{
            try {   
                const response = await axios.get(`${URLAPI+'enseignes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let enseignes:Enseigne[]=[];
                for(const element of data){
                    enseignes.push({
                        id:element['id'],
                        '@id':element['@id'],
                        nom:element['nom'],
                        typesMagasin: element['typesMagasin'],
                        sousGroupes:element['sousGroupes'],
                        fichiers:element['fichiers']
                    });
                }
                return enseignes;
            } catch (error) {
                errorService().handleError('Erreur lors du getEnseignes', error);
                return [];
            }
        },

        async getEnseignesTypesMagasinsForAdmin(token:string){
            let enseignes:Enseigne[]=[];
            try {   
                const response = await axios.get(`${URLAPI+'enseignes'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });

                const data = response.data['hydra:member'];
                for(const element of data){
                    enseignes.push({
                        id:element['id'],
                        '@id':element['@id'],
                        nom:element['nom'],
                        typesMagasin: element['typesMagasin'].map((type: any)=>{return {'@id':type}}),
                        sousGroupes:element['sousGroupes'].map((sousGroupe: any)=>{return {'@id':sousGroupe}}),
                        fichiers:element['fichiers'],
                    });
                }

                const typesMagasin = await TypeMagasinService().getTypesMagasins(token);
                const sousGroupes = await SousGroupeService().getSousGroupesForAdmin(token);

                for(const enseigne of enseignes){
                    const typeMagasinFiltres = typesMagasin.filter(type=>type.enseigne?.["@id"]===enseigne["@id"]);
                    const sousGroupesFiltres = sousGroupes.filter(sousGroupe=>sousGroupe.enseigne?.["@id"]===enseigne["@id"]);
                    enseigne.typesMagasin=typeMagasinFiltres
                    enseigne.sousGroupes=sousGroupesFiltres
                }

                for(const type of typesMagasin){
                    const enseigne = enseignes.find(ens=>ens["@id"]===type.enseigne?.["@id"]);
                    if(enseigne)type.enseigne=enseigne
                }

                return {ens:enseignes, types:typesMagasin };

            } catch (error) {
                errorService().handleError('Erreur lors du getEnseignesForEditAddMagasinsAdmin', error);
                return {ens:[], types:[] };
            }
        },

        /**
         * Cette méthode GET permet de récupérer les données autour d'une enseigne dans l'API,
         * en ne se concentrant que sur le strict minimum.
         * @param url 
         * @param token 
         * @returns un objet Enseigne avec des donnnées minimales
         */
        async getMinimalEnseigneFromUrlToPromiseToAnything(url:string, token:string){
            let enseigne:Enseigne = {
                id:0,
                nom:'',
                typesMagasin:undefined,
                sousGroupes:undefined,//temporaire
                fichiers:[]
            }
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                enseigne = {...enseigne,
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                    fichiers:data[0]['fichiers']
                }
                return enseigne;
            } catch (error) {
                return enseigne;
            }  
        },

        /**
         * Cette méthode GET permet de récupérer les données autour d'une enseigne dans l'API,
         * en ne se concentrant que sur le strict minimum.
         * @param url 
         * @param token 
         * @returns un objet Enseigne avec des donnnées minimales
         */
        async getMinimalEnseigneFromIDToPromiseToAnything(id:number, token:string){
            let enseigne:Enseigne = {
                id:0,
                nom:'',
                typesMagasin:undefined,
                sousGroupes:undefined,//temporaire
                fichiers:[]
            }
            try {
                const response = await axios.get(`${URLAPI+'enseigne/'+id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                enseigne = {...enseigne,
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                    fichiers:data[0]['fichiers']
                }
                return enseigne;
            } catch (error) {
                return enseigne;
            }  
        },

        async getEnseigneFromUrlToPromiseToTypeMagasin(url:string, token:string){
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                let enseigne:Enseigne = {
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                    fichiers:data[0]['fichiers'].map((fichier: any)=>{return {'@id':fichier}})
                }
                return enseigne;
            } catch (error) {
                let enseigne:Enseigne = {
                    id:0,
                    nom:'',
                    typesMagasin:undefined,
                    sousGroupes:undefined,//temporaire
                    fichiers:[]
                }
                return enseigne;
            }  
        },

        async deleteEnseigne(idEnseigne:number, token:any){
            const responseMagasin = await axios.delete(
            `${URLAPI}enseigne/${idEnseigne}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return responseMagasin.status;
        }
    }
}